import AvatharProfile from "./avathar-profile";

export default AvatharProfile